document.addEventListener("DOMContentLoaded", function () {
    // 공통 함수 - 에러 메시지 표시
    function showError(form, message) {
        let errorElement = form.querySelector(".form-error");

        if (!errorElement) {
            errorElement = document.createElement("div");
            errorElement.className = "form-error";
            // 버튼 앞에 에러 메시지 삽입
            const buttonWrap = form.querySelector(".button-wrap");
            form.insertBefore(errorElement, buttonWrap);
        }

        errorElement.textContent = message;
    }

    // 공통 함수 - 에러 메시지 제거
    function removeError(form, input = null) {
        const errorElement = form.querySelector(".form-error");
        if (errorElement) {
            errorElement.remove();
        }

        if (input) {
            input.closest(".form-group").classList.remove("error");
        }
    }

    // 패턴 너비 조정 함수
    window.adjustPatternWidth =
        window.adjustPatternWidth ||
        function (element) {
            // 요소의 패턴 너비 조정 로직
        };

    // === 로그인 폼 처리 ===
    const loginForm = document.getElementById("login-form");
    const loginButton = document.getElementById("login-button");

    if (loginForm) {
        // 이메일, 비밀번호 입력 시 에러 메시지 제거
        const emailInput = document.getElementById("customer_email");
        const passwordInput = document.getElementById("customer_password");

        if (emailInput) emailInput.addEventListener("input", () => removeError(loginForm, emailInput));
        if (passwordInput) passwordInput.addEventListener("input", () => removeError(loginForm, passwordInput));

        // 로그인 버튼 클릭 이벤트 (버튼 존재하는 경우)
        if (loginButton) {
            // 이메일, 비밀번호 입력 필드에서 엔터 키 이벤트 처리
            emailInput.addEventListener("keypress", function (event) {
                if (event.key === "Enter") {
                    event.preventDefault(); // 기본 제출 동작 방지
                    loginButton.click(); // 로그인 버튼 클릭 효과
                }
            });

            passwordInput.addEventListener("keypress", function (event) {
                if (event.key === "Enter") {
                    event.preventDefault(); // 기본 제출 동작 방지
                    loginButton.click(); // 로그인 버튼 클릭 효과
                }
            });

            loginButton.addEventListener("click", function () {
                const email = emailInput.value;
                const password = passwordInput.value;

                if (!email) {
                    emailInput.closest(".form-group").classList.add("error");
                }

                if (!password) {
                    passwordInput.closest(".form-group").classList.add("error");
                }

                // 필드 검증
                if (!email || !password) {
                    showError(loginForm, "이메일과 비밀번호는 필수 입력 항목입니다.");
                    return;
                }

                // 로그인 폼 제출
                loginForm.submit();
            });
        }
    }

    // === 회원가입 폼 처리 ===
    const registerForm = document.getElementById("register-form");
    const registerButton = document.getElementById("register-button");

    if (registerForm) {
        // 입력 필드 변경 시 에러 메시지 제거
        const inputFields = registerForm.querySelectorAll("input");
        inputFields.forEach((input) => {
            input.addEventListener("input", () => removeError(registerForm, input));
        });

        // 회원가입 버튼 클릭 이벤트
        if (registerButton) {
            registerButton.addEventListener("click", function () {
                validateAndSubmitRegister();
            });
        }

        // 폼 제출 이벤트
        registerForm.addEventListener("submit", function (e) {
            // 버튼으로 처리하지 않는 경우에만 여기서 처리 (엔터키 등)
            if (!registerButton) {
                e.preventDefault();
                validateAndSubmitRegister();
            }
        });

        // 폼 유효성 검사 및 제출
        function validateAndSubmitRegister() {
            const firstNameInput = document.getElementById("first_name");
            const lastNameInput = document.getElementById("last_name");
            const emailInput = document.getElementById("email");
            const passwordInput = document.getElementById("password");

            const firstName = firstNameInput.value;
            const lastName = lastNameInput.value;
            const email = emailInput.value;
            const password = passwordInput.value;

            if (!firstName) {
                firstNameInput.closest(".form-group").classList.add("error");
            }

            if (!lastName) {
                lastNameInput.closest(".form-group").classList.add("error");
            }

            if (!email) {
                emailInput.closest(".form-group").classList.add("error");
            }

            if (!password) {
                passwordInput.closest(".form-group").classList.add("error");
            }

            if (!firstName || !lastName || !email || !password) {
                showError(registerForm, "*는 필수 입력 항목입니다.");
                return;
            }

            if (!firstName || !lastName) {
                showError(registerForm, "이름은 필수 입력 항목입니다.");
                return;
            }

            // 기본 유효성 검사
            if (!email || !password) {
                showError(registerForm, "이메일과 비밀번호는 필수 입력 항목입니다.");
                return;
            }

            // 비밀번호 길이 확인
            // 비밀번호 규칙: 영문 대소문자/숫자/특수문자 중 2가지 이상 조합, 10자~16자
            const hasUpperCase = /[A-Z]/.test(password);
            const hasLowerCase = /[a-z]/.test(password);
            const hasNumber = /[0-9]/.test(password);
            const hasSpecial = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password);

            // 조합 조건 확인
            const combinationCount = [hasUpperCase, hasLowerCase, hasNumber, hasSpecial].filter(Boolean).length;

            // 길이 및 조합 조건 확인
            if (password.length < 10 || password.length > 16 || combinationCount < 2) {
                showError(registerForm, "비밀번호는 영문 대소문자/숫자/특수문자 중 2가지 이상 조합, 10자~16자이어야 합니다.");
                return;
            }

            // 폼 제출
            registerForm.submit();
        }
    }

    // === 비밀번호 찾기 폼 처리 ===
    const recoverForm = document.getElementById("recover-form");
    const recoverButton = document.getElementById("recover-button");

    if (recoverForm && recoverButton) {
        // 이메일 입력 시 에러 메시지 제거
        const emailInput = document.getElementById("recover_email");

        if (emailInput) {
            emailInput.addEventListener("input", () => removeError(recoverForm, emailInput));

            // 엔터 키 이벤트 처리
            emailInput.addEventListener("keypress", function (event) {
                if (event.key === "Enter") {
                    event.preventDefault();
                    recoverButton.click();
                }
            });
        }

        // 비밀번호 찾기 버튼 클릭 이벤트
        recoverButton.addEventListener("click", function () {
            const email = emailInput.value.trim();

            if (!email) {
                emailInput.closest(".form-group").classList.add("error");
                showError(recoverForm, "이메일은 필수 입력 항목입니다.");
                return;
            }

            // 이메일 유효성 검사
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email)) {
                emailInput.closest(".form-group").classList.add("error");
                showError(recoverForm, "유효한 이메일 주소를 입력해주세요.");
                return;
            }

            // 폼 제출
            recoverForm.submit();
        });
    }

    // 모든 폼의 버튼에 대해 pattern width 적용
    const formGroups = document.querySelectorAll(".form-group, .button-wrap .button");
    formGroups.forEach((formGroup) => {
        adjustPatternWidth(formGroup);

        const observer = new ResizeObserver((entries) => {
            for (const entry of entries) {
                adjustPatternWidth(entry.target);
            }
        });

        observer.observe(formGroup);
    });

    window.addEventListener("resize", function () {
        formGroups.forEach((formGroup) => {
            if (window.adjustPatternWidth) {
                window.adjustPatternWidth(formGroup);
            }
        });
    });
});
